import { SPHUserRole } from './sph-user.model';

export class SPHLoggedInUser {
    public static fromJSON(json: any): SPHLoggedInUser {
        const company = new SPHLoggedInUser();
        Object.getOwnPropertyNames(company).forEach( (propertyName) => {
                company[propertyName] = json[propertyName];
        });
        return company;
    }

    public username: string = undefined;
    public role: number = undefined;
    public jwt: string = undefined;
    public adminForCompany: any = undefined;

    get isUniAdmin(): boolean {
        return this.role >= SPHUserRole.Admin;
    }

    get isCompanyAdmin(): boolean {
        return this.role >= SPHUserRole.User;
    }
}



// WEBPACK FOOTER //
// ./src/app/features/shared/model/sph-logged-in-user.model.ts